import $ from "jquery";

const mijnAutoForm = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            parent: ".SingleInfoCarForm__Ander",
            selectIfLease: ".SingleInfoCarForm__Ander #is-lease",
        };
        if ($(el.parent).length === 0) return;

        // show 2 fields if select 'Ja' on 'Loopt er een leascontract?'
        $(document).on("change", el.selectIfLease, function () {
            const optionVal = $(this).find("option:selected").val();

            if (optionVal == "true") {
                $("#place-lease-wrapper").show();
                $("#outstanding-balance-wrapper").show();
                $(el.datePlan).prop("required", true);
            } else {
                $("#place-lease-wrapper").hide();
                $("#outstanding-balance-wrapper").hide();
                $(el.datePlan).removeAttr("required");
            }
        });
    };
    init();
};

try {
    mijnAutoForm();
} catch (error) {
    console.error("mijnAutoForm", error);
}
